// extracted by mini-css-extract-plugin
export default {"productGallery":"vF-z","inQuickShop":"wF-z"};